export default __webpack_public_path__ + "static/media/profileThumb.6537f30a.png";